import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumns3Wide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconColumns3Wide"><Path d="M7.58984 20H2V4H7.58984V20Z" fill="currentColor"/><Path d="M14.9102 20H9.08984V4H14.9102V20Z" fill="currentColor"/><Path d="M22 20H16.4102V4H22V20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumns3Wide;
